import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Modal from '../../../../../_common/Modal/Modal';
import TableAndPagination from '../../../../../_common/TableAndPagination/TableAndPagination';
import Loader from '../../../../../_common/Loader/Loader';
import Api from '../../../../../../api/api';
import classes from '../../../dashboard.module.scss';

const initialState = {
  firstLoad: true,
  loading: false,
  list: [],
  total: 0,
  totalPages: 1,
  page: 1,
  limit: 15,
};

const TopMedicationsModal = ({
  isOpen, requestData, tableHeader, isAdmin, onClose,
}) => {
  const navigate = useNavigate();

  const [medications, setMedications] = useState(initialState);

  const {
    page, limit, total, totalPages,
  } = medications;

  useEffect(() => {
    if (!isOpen) {
      setMedications(initialState);

      return;
    }

    (async () => {
      try {
        setMedications((prev) => ({ ...prev, loading: true }));

        const { data } = await Api.getDashboardTopMedications({
          ...requestData,
          page,
          limit,
          cancelKey: 'getDashboardTopMedicationsList',
        });

        setMedications((prev) => ({
          ...prev,
          list: (data?.data?.response || []).map((d, i) => ({
            ...d,
            id: d.productId,
            rank: (page - 1) * limit + i + 1,
            drugType: d.drugType || '-',
          })),
          total: data?.data?._meta?.total || 0,
          totalPages: data?.data?._meta?.pageCount || 1,
          loading: false,
          firstLoad: false,
        }));
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [isOpen, requestData, page, limit]);

  const onChangePageData = (path, value) => {
    setMedications((prev) => (path === 'limit'
      ? { ...prev, limit: value, page: 1 }
      : { ...prev, page: value }));
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className={classes.kpi_modal}
    >
      <div className={classes.kpi_modal_content}>
        <h2>Top medications</h2>

        {!medications.firstLoad && (
          <div className={classes.kpi_modal_caption}>
            <span>{`${total} medications`}</span>
          </div>
        )}

        <div className={classes.kpi_modal_table}>
          {medications.firstLoad
            ? (
              <div className={classes.kpi_modal_loader}>
                <Loader />
              </div>
            )

            : (
              <TableAndPagination
                header={tableHeader}
                data={medications.list}
                loading={medications.loading}
                className={isAdmin ? classes.clickable_row : ''}
                onClick={(productId) => isAdmin && navigate(`/products/${productId}/edit`)}
                onChange={onChangePageData}
                totalPage={totalPages}
                page={page - 1}
                limit={limit}
              />
            )}
        </div>
      </div>
    </Modal>
  );
};

TopMedicationsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  requestData: PropTypes.object.isRequired,
  tableHeader: PropTypes.array.isRequired,
  isAdmin: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default TopMedicationsModal;
